var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"figure-painting"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":"300"}},[_c('router-view')],1),_c('div',{class:[
      'toast-center',
      { hidden: !_vm.uploading && !_vm.createing }
    ]},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"載入中..."}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }